import { createReducer } from '@reduxjs/toolkit';
import { initialModalState as initialState } from './state';
import * as actions from './action';
import { setNestedField } from '../utils';

export default createReducer(initialState(), (builder) => {
  builder
    .addCase(actions.setModal, (state, { payload: { field, value } }) => {
      setNestedField(state, field, value);
    })
    .addCase(actions.resetModal, (state) => {
      return initialState();
    });
});
